export const parseScreenResolution = (resolution, type) => {
  const [width, height] = resolution?.split("x")?.map(Number);
  if (type === "width") return width;
  if (type === "height") return height;
};
